export var MaintenanceScheduleType;
(function (MaintenanceScheduleType) {
    MaintenanceScheduleType["Normal"] = "normal";
    MaintenanceScheduleType["Severe"] = "severe";
})(MaintenanceScheduleType || (MaintenanceScheduleType = {}));
